export default {
  dashboardFigures: state => state.dashboard.figures,
  dashboardStats: state => state.dashboard.stats,
  isSidebarHidden: state => state.sidebar.hidden,
  isSidebarMinimised: state => state.sidebar.minimised,
  isMobileSidebarHidden: state => !state.mobileSidebar,
}
